import { render, staticRenderFns } from "./SectionNew.vue?vue&type=template&id=b2d91daa&"
import script from "./SectionNew.vue?vue&type=script&lang=js&"
export * from "./SectionNew.vue?vue&type=script&lang=js&"
import style0 from "./SectionNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d91daa')) {
      api.createRecord('b2d91daa', component.options)
    } else {
      api.reload('b2d91daa', component.options)
    }
    module.hot.accept("./SectionNew.vue?vue&type=template&id=b2d91daa&", function () {
      api.rerender('b2d91daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SectionNew.vue"
export default component.exports